import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme, media } from 'styles';
import { Container, Breadcrumbs } from 'components/shared';

const { sp, colors } = theme;

const CaseStudyBreadcrumbs = styled(Breadcrumbs)``;

const BannerContainer = styled(Container)`
  height: 100%;

  ${media.tablet`
    display: flex;
  `};
`;

const StyledHeader = styled.div`
  background-color: ${theme.colors.white};

  ${media.tablet`
    height: 600px;
  `};

  h1 {
    max-width: 600px;
    padding-top: ${sp.xl};
    font-size: 30px;
    line-height: 36px;
    color: ${colors.navy};

    ${media.tablet`
      padding-top: ${sp.max};
      font-size: 40px;
      line-height: 47px;
    `};

    ${media.laptop`
      font-size: 48px;
      line-height: 58px;
    `};
  }
`;

const BannerContent = styled.div`
  padding-top: ${sp.l};
  position: relative;
  width: 100%;

  ${media.tablet`
    padding-top: ${sp.max};
    padding-right: ${sp.max};
    width: 50%;
  `};
`;

const BannerImage = styled.div`
  width: 100%;

  ${media.tablet`
    width: 50%;
  `};

  img {
    display: block;
    position: relative;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    bottom: -50px;

    ${media.tablet`
      max-width: none;
      bottom: -100px;
  `};
  }
`;

function Header({ heading, image, slug, excerpt }) {
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Work',
      link: '/work',
    },
    {
      name: heading,
      link: `/work/${slug}`,
    },
  ];
  return (
    <StyledHeader>
      <BannerContainer>
        <BannerContent>
          <CaseStudyBreadcrumbs breadcrumbs={breadcrumbs} left />
          <h1>{excerpt}</h1>
        </BannerContent>
        <BannerImage>
          <img src={image.responsiveResolution.src} alt={image.heading} />
        </BannerImage>
      </BannerContainer>
    </StyledHeader>
  );
}

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/components/Header/Header.jsx